// This is in use in the theme & contains hero slider etc...
! function(t) {
    function e(e) {
        for (var o, a, r = e[0], l = e[1], c = e[2], u = 0, f = []; u < r.length; u++) a = r[u], s[a] && f.push(s[a][0]), s[a] = 0;
        for (o in l) Object.prototype.hasOwnProperty.call(l, o) && (t[o] = l[o]);
        for (h && h(e); f.length;) f.shift()();
        return i.push.apply(i, c || []), n()
    }

    function n() {
        for (var t, e = 0; e < i.length; e++) {
            for (var n = i[e], o = !0, r = 1; r < n.length; r++) {
                var l = n[r];
                0 !== s[l] && (o = !1)
            }
            o && (i.splice(e--, 1), t = a(a.s = n[0]))
        }
        return t
    }
    var o = {},
        s = {
            1: 0
        },
        i = [];

    function a(e) {
        if (o[e]) return o[e].exports;
        var n = o[e] = {
            i: e,
            l: !1,
            exports: {}
        };
        return t[e].call(n.exports, n, n.exports, a), n.l = !0, n.exports
    }
    a.m = t, a.c = o, a.d = function(t, e, n) {
        a.o(t, e) || Object.defineProperty(t, e, {
            enumerable: !0,
            get: n
        })
    }, a.r = function(t) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(t, "__esModule", {
            value: !0
        })
    }, a.t = function(t, e) {
        if (1 & e && (t = a(t)), 8 & e) return t;
        if (4 & e && "object" == typeof t && t && t.__esModule) return t;
        var n = Object.create(null);
        if (a.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: t
            }), 2 & e && "string" != typeof t)
            for (var o in t) a.d(n, o, function(e) {
                return t[e]
            }.bind(null, o));
        return n
    }, a.n = function(t) {
        var e = t && t.__esModule ? function() {
            return t.default
        } : function() {
            return t
        };
        return a.d(e, "a", e), e
    }, a.o = function(t, e) {
        return Object.prototype.hasOwnProperty.call(t, e)
    }, a.p = "";
    var r = window.shopifySlateJsonp = window.shopifySlateJsonp || [],
        l = r.push.bind(r);
    r.push = e, r = r.slice();
    for (var c = 0; c < r.length; c++) e(r[c]);
    var h = l;
    i.push([21, 0]), n()
}({
    21: function(t, e, n) {
        "use strict";
        n(22), n(23), n(24), n(25), n(2), n(26), n(28), n(29), n(30), n(31);
        var o = n(45),
            s = n(46);
        (0, o.focusHash)(), (0, o.bindInPageLinks)(), (0, s.cookiesEnabled)() && (document.documentElement.className = document.documentElement.className.replace("supports-no-cookies", "supports-cookies"))
    },
    28: function(t, e) {},
    29: function(t, e) {},
    30: function(t, e, n) {
        "use strict";
        var o, s, i;
        /*!
         * The Final Countdown for jQuery v2.2.0 (http://hilios.github.io/jQuery.countdown/)
         * Copyright (c) 2016 Edson Hilios
         * 
         * Permission is hereby granted, free of charge, to any person obtaining a copy of
         * this software and associated documentation files (the "Software"), to deal in
         * the Software without restriction, including without limitation the rights to
         * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
         * the Software, and to permit persons to whom the Software is furnished to do so,
         * subject to the following conditions:
         * 
         * The above copyright notice and this permission notice shall be included in all
         * copies or substantial portions of the Software.
         * 
         * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
         * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
         * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
         * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
         * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
         * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
         */
        s = [n(1)], void 0 === (i = "function" == typeof(o = function(t) {
            function e(t) {
                var e = t.toString().replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1");
                return new RegExp(e)
            }

            function n(t) {
                return function(n) {
                    var s = n.match(/%(-|!)?[A-Z]{1}(:[^;]+;)?/gi);
                    if (s)
                        for (var i = 0, a = s.length; i < a; ++i) {
                            var l = s[i].match(/%(-|!)?([a-zA-Z]{1})(:[^;]+;)?/),
                                c = e(l[0]),
                                h = l[1] || "",
                                u = l[3] || "",
                                f = null;
                            l = l[2], r.hasOwnProperty(l) && (f = r[l], f = Number(t[f])), null !== f && ("!" === h && (f = o(u, f)), "" === h && f < 10 && (f = "0" + f.toString()), n = n.replace(c, f.toString()))
                        }
                    return n.replace(/%%/, "%")
                }
            }

            function o(t, e) {
                var n = "s",
                    o = "";
                return t && (1 === (t = t.replace(/(:|;|\s)/gi, "").split(/\,/)).length ? n = t[0] : (o = t[0], n = t[1])), Math.abs(e) > 1 ? n : o
            }
            var s = [],
                i = [],
                a = {
                    precision: 100,
                    elapse: !1,
                    defer: !1
                };
            i.push(/^[0-9]*$/.source), i.push(/([0-9]{1,2}\/){2}[0-9]{4}( [0-9]{1,2}(:[0-9]{2}){2})?/.source), i.push(/[0-9]{4}([\/\-][0-9]{1,2}){2}( [0-9]{1,2}(:[0-9]{2}){2})?/.source), i = new RegExp(i.join("|"));
            var r = {
                    Y: "years",
                    m: "months",
                    n: "daysToMonth",
                    d: "daysToWeek",
                    w: "weeks",
                    W: "weeksToMonth",
                    H: "hours",
                    M: "minutes",
                    S: "seconds",
                    D: "totalDays",
                    I: "totalHours",
                    N: "totalMinutes",
                    T: "totalSeconds"
                },
                l = function(e, n, o) {
                    this.el = e, this.$el = t(e), this.interval = null, this.offset = {}, this.options = t.extend({}, a), this.instanceNumber = s.length, s.push(this), this.$el.data("countdown-instance", this.instanceNumber), o && ("function" == typeof o ? (this.$el.on("update.countdown", o), this.$el.on("stoped.countdown", o), this.$el.on("finish.countdown", o)) : this.options = t.extend({}, a, o)), this.setFinalDate(n), !1 === this.options.defer && this.start()
                };
            t.extend(l.prototype, {
                start: function() {
                    null !== this.interval && clearInterval(this.interval);
                    var t = this;
                    this.update(), this.interval = setInterval(function() {
                        t.update.call(t)
                    }, this.options.precision)
                },
                stop: function() {
                    clearInterval(this.interval), this.interval = null, this.dispatchEvent("stoped")
                },
                toggle: function() {
                    this.interval ? this.stop() : this.start()
                },
                pause: function() {
                    this.stop()
                },
                resume: function() {
                    this.start()
                },
                remove: function() {
                    this.stop.call(this), s[this.instanceNumber] = null, delete this.$el.data().countdownInstance
                },
                setFinalDate: function(t) {
                    this.finalDate = function(t) {
                        if (t instanceof Date) return t;
                        if (String(t).match(i)) return String(t).match(/^[0-9]*$/) && (t = Number(t)), String(t).match(/\-/) && (t = String(t).replace(/\-/g, "/")), new Date(t);
                        throw new Error("Couldn't cast `" + t + "` to a date object.")
                    }(t)
                },
                update: function() {
                    if (0 !== this.$el.closest("html").length) {
                        var e, n = void 0 !== t._data(this.el, "events"),
                            o = new Date;
                        e = this.finalDate.getTime() - o.getTime(), e = Math.ceil(e / 1e3), e = !this.options.elapse && e < 0 ? 0 : Math.abs(e), this.totalSecsLeft !== e && n && (this.totalSecsLeft = e, this.elapsed = o >= this.finalDate, this.offset = {
                            seconds: this.totalSecsLeft % 60,
                            minutes: Math.floor(this.totalSecsLeft / 60) % 60,
                            hours: Math.floor(this.totalSecsLeft / 60 / 60) % 24,
                            days: Math.floor(this.totalSecsLeft / 60 / 60 / 24) % 7,
                            daysToWeek: Math.floor(this.totalSecsLeft / 60 / 60 / 24) % 7,
                            daysToMonth: Math.floor(this.totalSecsLeft / 60 / 60 / 24 % 30.4368),
                            weeks: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 7),
                            weeksToMonth: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 7) % 4,
                            months: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 30.4368),
                            years: Math.abs(this.finalDate.getFullYear() - o.getFullYear()),
                            totalDays: Math.floor(this.totalSecsLeft / 60 / 60 / 24),
                            totalHours: Math.floor(this.totalSecsLeft / 60 / 60),
                            totalMinutes: Math.floor(this.totalSecsLeft / 60),
                            totalSeconds: this.totalSecsLeft
                        }, this.options.elapse || 0 !== this.totalSecsLeft ? this.dispatchEvent("update") : (this.stop(), this.dispatchEvent("finish")))
                    } else this.remove()
                },
                dispatchEvent: function(e) {
                    var o = t.Event(e + ".countdown");
                    o.finalDate = this.finalDate, o.elapsed = this.elapsed, o.offset = t.extend({}, this.offset), o.strftime = n(this.offset), this.$el.trigger(o)
                }
            }), t.fn.countdown = function() {
                var e = Array.prototype.slice.call(arguments, 0);
                return this.each(function() {
                    var n = t(this).data("countdown-instance");
                    if (void 0 !== n) {
                        var o = s[n],
                            i = e[0];
                        l.prototype.hasOwnProperty(i) ? o[i].apply(o, e.slice(1)) : null === String(i).match(/^[$A-Z_][0-9A-Z_$]*$/i) ? (o.setFinalDate.call(o, i), o.start()) : t.error("Method %s does not exist on jQuery.countdown".replace(/\%s/gi, i))
                    } else new l(this, e[0], e[1])
                })
            }
        }) ? o.apply(e, s) : o) || (t.exports = i)
    },
    31: function(t, e, n) {
        "use strict";
        var o = function(t) {
            return t && t.__esModule ? t : {
                default: t
            }
        }(n(32));
        $(document).foundation(), $(window).on("load resize orientationchange", function() {
            $(".slider-offers").each(function() {
                var t = $(this);
                $(window).width() > 1024 ? t.hasClass("slick-initialized") && t.slick("unslick") : t.hasClass("slick-initialized") || t.slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    mobileFirst: !0,
                    arrows: !1,
                    autoplay: !0,
                  autoplaySpeed: 10000,
                  speed: 1000
                })
            })
        }), $(".hero-slider").slick((0, o.default)({
            arrows: !1,
            autoplay: !0,
            centerMode: !1,
            slidesToShow: 1,
            autoplaySpeed: 8000,
          	dots: true,
            speed: 500,
            variableWidth: !1,
          	pauseOnHover: !1,
            infinite: !0,
          	fade: !0,
    		pauseOnFocus: true,
    		adaptiveHeight: true,
  			cssEase: 'linear'
        }, "slidesToShow", 1)), $("#searchButton").click(function() {
            $(this).toggleClass("on"), $(".search-bar").slideToggle()
        })
    }
});